"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
function Welcome() {
    var i18n = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).i18n;
    var welcomeUrl = i18n.language === "da" ? "https://nordic-screen.com/dashboard-dk/" : "https://nordic-screen.com/dashboard-en/";
    return (react_1.default.createElement("div", { className: "w-100 h-100" },
        react_1.default.createElement("embed", { src: welcomeUrl, style: { width: "100%", height: "99%" } })));
}
exports.default = Welcome;
